import React, { memo } from 'react';
import { Search, X } from 'lucide-react';

/**
 * Search input field with clear button
 */
const SearchInput = memo(({ 
  searchQuery, 
  setSearchQuery, 
  handleSearchKeyDown, 
  searchInputRef, 
  clearSearchInput 
}) => (
  <div className="flex-1 relative">
    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <Search size={14} className="text-neutral-400" />
    </div>
    <input
      ref={searchInputRef}
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={handleSearchKeyDown}
      placeholder="Search in chat..."
      className="w-full p-2 pl-9 pr-9 text-sm bg-slate-100 dark:bg-neutral-800 border border-slate-300 dark:border-neutral-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent dark:text-white placeholder-neutral-500 transition-all"
    />
    {searchQuery && (
      <button
        onClick={clearSearchInput}
        className="absolute inset-y-0 right-0 pr-3 flex items-center"
        title="Clear search text"
      >
        <X size={14} className="text-neutral-400 hover:text-neutral-600 dark:hover:text-neutral-300 transition-colors" />
      </button>
    )}
  </div>
));

SearchInput.displayName = 'SearchInput';

export default SearchInput;